<template>
  <div class="navbar-pai">
    <div :class="navbarStatus ? 'navbar-shadow' : 'no-shadow'" />
    <b-navbar id="navbar" toggleable="lg" fixed="top">
      <b-navbar-toggle target="nav-collapse" class="ml-auto">
        <template #default="{ expanded }">
          <div id="menuNav" :class="{ open: expanded }" @click="NavbarStatus()">
            <span id="bar1"></span>
            <span id="bar2"></span>
            <span id="bar3"></span>
          </div>
        </template>
      </b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto mr-auto" align="center" tag="h5">
          <b-nav-item id="home">
            <a href="/" @click="$router.push({ name: 'Home' })">
              Home
            </a>
          </b-nav-item>
          <b-nav-item id="perguntas">
            <a href="/perguntas" @click="$router.push({ name: 'perguntas' })">
              Perguntas
            </a></b-nav-item
          >
          <b-nav-item id="acolhimento">
            <a href="/acolhimento" @click="$router.push({ name: 'reception' })">
              Acolhimento
            </a></b-nav-item
          >
          <b-nav-item id="parcerias">
            <a href="/parcerias" @click="$router.push({ name: 'partners' })">
              Parcerias
            </a></b-nav-item
          >
          <b-nav-item id="postagens"
            ><a href="/postagens" @click="$router.push({ name: 'HomePostagens' })">
              Postagens
            </a></b-nav-item
          >
          <b-nav-item id="blog">
            <router-link
              :to="{
                name: 'Blog Home',
              }"
            >
              Blog
            </router-link>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
export default {
  name: 'Navbar',
  data() {
    return {
      navbarStatus: false,
      menuOpen: false,
    };
  },
  methods: {
    NavbarStatus() {
      this.navbarStatus = !this.navbarStatus;
    },
  },
};
</script>
<style lang="scss">
.navbar-pai {
  .navbar-shadow {
    min-height: 100vh;
    width: 100vw;
    position: fixed;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.36);
    //box-shadow: 100vh 100vh 0px 100vmax rgba(0, 0, 0, 0.36);
  }
  .no-shadow {
    background-color: none;
  }
  .navbar {
    background-color: #a33965;
  }
  #home {
    width: 76px;
    margin-right: 2rem;
  }
  #postagens {
    width: 126px;
    margin-right: 2rem;
  }
  #blog {
    width: 66px;
  }
  #parcerias {
    width: 106px;
    margin-right: 2rem;
  }
  #acolhimento {
    width: 152px;
    margin-right: 2rem;
  }
  #perguntas {
    width: 125px;
    margin-right: 2rem;
  }

  .navbar-light .navbar-nav .nav-link {
    color: #fffaf4;
    font-family: 'Montserrat', sans-serif;
    // margin-right: 3vw;
  }
  .navbar-light .navbar-nav .nav-link:hover {
    font-weight: bolder;
    color: #fffaf4;
    font-family: 'Montserrat', sans-serif;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  a:hover {
    color: inherit;
    text-decoration: none;
  }
  .navbar-light .navbar-toggler {
    color: #fffaf4;
    border: none;
  }
  button:focus {
    outline: none;
  }

  /* Style icone*/
  #menuNav {
    width: 33px;
    height: 29px;
    position: relative;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: 0.5s ease-in-out;
    -moz-transition: 0.5s ease-in-out;
    -o-transition: 0.5s ease-in-out;
    transition: 0.5s ease-in-out;
    cursor: pointer;
  }

  #menuNav span {
    display: block;
    position: absolute;
    height: 3px;
    width: 100%;
    background: #ffff;
    border-radius: 5px;
    opacity: 1;
    left: 0;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: 0.35s ease-in-out;
    -moz-transition: 0.35s ease-in-out;
    -o-transition: 0.35s ease-in-out;
    transition: 0.35s ease-in-out;
  }

  #menuNav span:nth-child(1) {
    top: 0px;
    -webkit-transform-origin: left center;
    -moz-transform-origin: left center;
    -o-transform-origin: left center;
    transform-origin: left center;
  }

  #menuNav span:nth-child(2) {
    top: 10px;
    -webkit-transform-origin: left center;
    -moz-transform-origin: left center;
    -o-transform-origin: left center;
    transform-origin: left center;
  }

  #menuNav span:nth-child(3) {
    top: 20px;
    -webkit-transform-origin: left center;
    -moz-transform-origin: left center;
    -o-transform-origin: left center;
    transform-origin: left center;
  }

  #menuNav.open span:nth-child(1) {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
    top: -3px;
    left: 8px;
  }

  #menuNav.open span:nth-child(2) {
    width: 0%;
    opacity: 0;
  }

  #menuNav.open span:nth-child(3) {
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
    top: 20px;
    left: 8px;
  }

  @media (max-width: 991px) {
    .navbar .navbar-nav {
      display: inline-block;
      vertical-align: top;
    }
    .navbar .navbar-collapse {
      text-align: center;
    }
    #home,
    #postagens,
    #parcerias,
    #acolhimento,
    #perguntas,
    #blog {
      margin-right: inherit;
      width: inherit;
    }
  }
}
</style>
